import context from '../context'
import { dispatchError } from '@/utils/serverErrorHandler'
import { allowErrorDialog } from '@/utils/fetch'

const initialState = {
  availableCodeLists: [],
  codeListDetail: [],
  navigationEntities: [],
  currentCodeListType: null,
  processing: false,
  operationFailed: false
}

const actionTypes = {
  getAvailableCodeLists: 'codeListService/getAvailableCodeLists',
  getCodeListDetail: 'codeListService/getCodeListDetail',
  getNavigationEntities: 'codeListService/getNavigationEntities',
  startProcessing: 'codeListService/startProcessing',
  stopProcessing: 'codeListService/stopProcessing',
  deleteItem: 'codeListsService/deleteItem',
  restoreItem: 'codeListsService/restoreItem',
  updateItem: 'codeListsService/updateItem',
  createItem: 'codeListsService/createItem',
  clearCodeListDetail: 'codeListsService/clearCodeListDetail',
  existCodeChecking: 'codeListsService/existCodeChecking',
  codeListsError: 'codeListsService/error'
}

export const actionCreators = {
  getAvailableCodeLists: () => (dispatch) => {
    dispatch({ type: actionTypes.startProcessing })

    context.api.codeListService.getCodeLists(allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.getAvailableCodeLists, data: response })
      }).catch(() => dispatch({ type: actionTypes.codeListsError }))
  },

  getCodeListDetail: (codeListType) => (dispatch) => {
    dispatch({ type: actionTypes.clearCodeListDetail })

    context.api.codeListService.getCodeList(codeListType)
      .then(response => {
        dispatch({ type: actionTypes.getCodeListDetail, data: { type: codeListType, codeList: response } })
      }).catch(() => dispatch({ type: actionTypes.codeListsError }))
  },

  getNavigationEntities: (codeListType) => (dispatch) => {
    context.api.codeListService.getNavigationEntities(codeListType, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.getNavigationEntities, data: response })
      }).catch(() => dispatch({ type: actionTypes.codeListsError }))
  },

  createItem: (codeListItem) => (dispatch, getState) => {
    dispatch({ type: actionTypes.startProcessing })

    let state = getState()
    context.api.codeListService.createItem(codeListItem, state.codeLists.currentCodeListType, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.createItem, data: { item: codeListItem, id: response } })
        dispatch({ type: actionTypes.stopProcessing })
        dispatch(actionCreators.getCodeListDetail(state.codeLists.currentCodeListType))
      })
      .catch(error => {
        dispatch({ type: actionTypes.stopProcessing })
        dispatchError(dispatch, error)
      })
  },

  updateItem: (codeListItem) => (dispatch, getState) => {
    dispatch({ type: actionTypes.startProcessing })

    let state = getState()
    context.api.codeListService.updateItem(codeListItem, state.codeLists.currentCodeListType, allowErrorDialog)
      .then(() => {
        dispatch({ type: actionTypes.updateItem, data: { item: codeListItem } })
        dispatch({ type: actionTypes.stopProcessing })
        dispatch(actionCreators.getCodeListDetail(state.codeLists.currentCodeListType))
      }).catch(() => dispatch({ type: actionTypes.codeListsError }))
  },

  deleteItem: (id) => (dispatch, getState) => {
    dispatch({ type: actionTypes.startProcessing })

    let state = getState()
    context.api.codeListService.deleteItem(id, state.codeLists.currentCodeListType, allowErrorDialog)
      .then(() => {
        dispatch({ type: actionTypes.deleteItem, data: id })
        dispatch({ type: actionTypes.stopProcessing })
        dispatch(actionCreators.getCodeListDetail(state.codeLists.currentCodeListType))
      }).catch(() => dispatch({ type: actionTypes.codeListsError }))
  },

  restoreItem: (id) => (dispatch, getState) => {
    dispatch({ type: actionTypes.startProcessing })

    let state = getState()
    context.api.codeListService.restoreItem(id, state.codeLists.currentCodeListType, allowErrorDialog)
      .then(() => {
        dispatch({ type: actionTypes.stopProcessing })
        dispatch(actionCreators.getCodeListDetail(state.codeLists.currentCodeListType))
      })
      .catch(error => {
        dispatch({ type: actionTypes.stopProcessing })
        dispatchError(dispatch, error)
      })
  },

  existCode: (code) => (dispatch, getState) => {
    dispatch({ type: actionTypes.existCodeChecking, data: code })

    let state = getState()
    context.api.codeListService.existCode(code, state.codeLists.currentCodeListType)
      .catch(error => dispatchError(dispatch, error))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.clearCodeListDetail: {
      state = { ...state, processing: true, codeListDetail: [] }
      break
    }
    case actionTypes.getAvailableCodeLists: {
      state = { ...state, processing: false, availableCodeLists: action.data }
      break
    }
    case actionTypes.getCodeListDetail: {
      state = { ...state, processing: false, codeListDetail: action.data.codeList, currentCodeListType: action.data.type }
      break
    }
    case actionTypes.getNavigationEntities: {
      state = { ...state, navigationEntities: action.data }
      break
    }
    case actionTypes.startProcessing: {
      state = { ...state, processing: true }
      break
    }
    case actionTypes.stopProcessing: {
      state = { ...state, processing: false }
      break
    }
    case actionTypes.deleteItem: {
      let items = state.codeListDetail.filter(item => item.id !== action.data)

      state = { ...state, codeListDetail: items }
      break
    }
    case actionTypes.updateItem: {
      const items = state.codeListDetail.map(item => {
        if (item.id === action.data.item.id) {
          return { ...action.data.item }
        } else {
          return item
        }
      })

      state = { ...state, codeListDetail: items }

      break
    }
    case actionTypes.createItem: {
      const items = [...state.codeListDetail]
      items.push({ ...action.data.item, id: action.data.id })

      state = { ...state, codeListDetail: items }
      break
    }
    case actionTypes.codeListsError:
      return { ...state, processing: false }
    case actionTypes.existCodeChecking:
      return { ...state, existCodeChecked: action.data }
    default:
      break
  }
  return state
}



// WEBPACK FOOTER //
// ./src/store/CodeLists.js